import { useState, useEffect } from 'react';
import { FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import car1 from './img/1.jpg';
import car2 from './img/2.jpg';
import car3 from './img/3.jpg';
import car4 from './img/4.jpg';
import car5 from './img/5.jpg';
import car6 from './img/6.jpg';
import car7 from './img/7.jpg';
import car8 from './img/8.jpg';
import car9 from './img/9.jpg';
import car10 from './img/10.jpg';
import car11 from './img/11.jpg';
import car12 from './img/12.jpg';
import './App.css';

function App() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  return (
    <div className="App">
      <header className="navbar">
        <div className="logo">Dax Media</div>
        <nav>
          <ul className="nav-links">
            <li><a href="#hero">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      <section id="hero" className="hero">
        <div className="hero-text">
          <h1>Car Photography</h1>
          <p>
            Capturing performance and beauty through the lens like this 2007 BMW 335i with a built bottom end, TPC 19T Turbos, tuned by DocVu.
          </p>
          <a href="#gallery"><button className="cta-btn">View Gallery</button></a>
        </div>
        <div className="hero-image">
          <img src={car1} alt="BMW 335i" />
        </div>
      </section>

<section id="about" className="about">
  <h2>About Me</h2>
  <p>
    Welcome to <strong>Dax Media</strong>, where passion for performance meets photography.  
    I specialize in capturing the sleek lines, power, and essence of sports cars,  
    creating visuals that resonate with car enthusiasts and collectors alike.
  </p>
  <p>
    With years of experience in automotive photography, I have honed my ability to showcase every detail,  
    from polished exteriors to intricate engine components. My work blends technical skill with artistic vision,  
    ensuring each image tells a story and evokes the thrill of driving.
  </p>
  <p>
    I aim to create images that not only capture cars but also the lifestyle and culture surrounding them.  
    Whether it’s a high-speed track day, a serene show car presentation, or an adrenaline-filled motorsport event,  
    my goal is to bring the excitement and beauty of every vehicle to life.
  </p>
  <p>
    Through Dax Media, I hope to connect with fellow enthusiasts, collectors, and brands who appreciate the artistry  
    of automotive photography. Let’s celebrate the world of sports cars, one stunning image at a time.
  </p>

  <div className="featured-cars">
    <img src={car4} alt="Featured Car 4" />
    <img src={car2} alt="Featured Car 2" />
    <img src={car3} alt="Featured Car 3" />
  </div>
</section>



      <section id="services" className="services">
        <h2>Services</h2>
        <div className="service-grid">
          <div className="service-card">
            <h3>Car Photography</h3>
            <p>
              Professional photoshoots tailored to highlight the details and personality of your vehicle.
            </p>
          </div>
          <div className="service-card">
            <h3>Event Coverage</h3>
            <p>
              From car meets to track days capturing every thrilling moment with precision.
            </p>
          </div>
          <div className="service-card">
            <h3>Custom Edits</h3>
            <p>
              High-quality post-processing to deliver sharp, dynamic, and impactful automotive imagery.
            </p>
          </div>
        </div>
      </section>

      <section id="gallery" className="gallery">
        <h2>Sports Car Gallery</h2>
        <div className="gallery-grid">
          <img src={car1} alt="Car 1" />
          <img src={car2} alt="Car 2" />
          <img src={car3} alt="Car 3" />
          <img src={car4} alt="Car 4" />
          <img src={car5} alt="Car 5" />
          <img src={car6} alt="Car 6" />
          <img src={car7} alt="Car 7" />
          <img src={car8} alt="Car 8" />
          <img src={car9} alt="Car 9" />
          <img src={car10} alt="Car 10" />
          <img src={car11} alt="Car 11" />
          <img src={car12} alt="Car 12" />
        </div>
      </section>

      <section id="contact" className="contact">
        <h2>Contact Me</h2>
        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit" className="cta-btn">Send Message</button>
        </form>
        
      </section>

      <footer className="footer">
        <div className="social-icons">
          <a href="https://instagram.com/days.e92" target="_blank" rel="noreferrer"><FaInstagram /></a>
          <a href="https://linkedin.com/in/damon-morgan" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
        </div>
        <p className="copyright">
          © {new Date().getFullYear()} Dax Media. All rights reserved.
        </p>
        <br></br>
        <p>Site developed by: <a href='https://damonmorgan.net'>Damon M</a></p>
      </footer>

      {showButton && (
        <button className="back-to-top" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </div>
  );
}

export default App;
